class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');

    overlay.addEventListener('click', (evt) => {
      if (evt.target === overlay) {
        this.close();
      }
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );


    /* lock scroll position */
    this._scrollY = window.scrollY;
    // document.body.style.position = 'fixed';
    /* compensate for missing scrollbar so content doesn't shift */
    const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarGap > 0) document.body.style.paddingRight = `${scrollBarGap}px`;
    document.body.style.top = `-${this._scrollY}px`;

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    /* unlock scroll and restore previous position */
    const savedY = this._scrollY || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.paddingRight = '';

    /* wait one frame so the browser applies new layout, then scroll back */
    requestAnimationFrame(() => window.scrollTo(0, savedY));
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (section.selector === '#CartDrawer') {
        const htmlString = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

        const newSectionElement = document
        .createRange()
        .createContextualFragment(htmlString);

        const headerDrawer = document.getElementById('CartDrawer-Header');
        const itemsDrawer = document.getElementById('CartDrawer-Items');
        const footerDrawer = document.getElementById('CartDrawer-Footer');
        const headerDrawerNew = newSectionElement.querySelector('#CartDrawer-Header');
        const itemsDrawerNew = newSectionElement.querySelector('#CartDrawer-Items');
        const footerDrawerNew = newSectionElement.querySelector('#CartDrawer-Footer');
         if (headerDrawer && headerDrawerNew) {
          headerDrawer.innerHTML = headerDrawerNew.innerHTML;
        }
        if (itemsDrawer && itemsDrawerNew) {
          itemsDrawer.innerHTML = itemsDrawerNew.innerHTML;
        }
        if (footerDrawer && footerDrawerNew) {
          footerDrawer.innerHTML = footerDrawerNew.innerHTML;
        }
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }      
    });
    // Sync Continue Shopping link in empty state from cart-drawer dataset
    const continueShoppingLink = this?.dataset?.continueShoppingLink;
    if (continueShoppingLink) {
      const emptyCta = this.querySelector('.drawer__inner-empty .continue-shopping-link');
      if (emptyCta) emptyCta.setAttribute('href', continueShoppingLink);
    }
    const overlay = this.querySelector('#CartDrawer-Overlay');
    setTimeout(() => {
      overlay.addEventListener('click', (evt) => {
        if (evt.target === overlay) {
          this.close();
        }
      });
      this.open();
      // Ensure loyalty banner and other listeners refresh after drawer re-render
      try {
        if (typeof updateDrawerPointsFromServer === 'function') {
          updateDrawerPointsFromServer();
        } else {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then((r) => r.json())
            .then((cart) => {
              if (typeof refreshAllLoyaltyBanners === 'function') {
                refreshAllLoyaltyBanners(cart);
              }
              if (typeof fireCartUpdated === 'function') {
                fireCartUpdated(cart);
              } else {
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
              }
            })
            .catch(() => {});
        }
      } catch (e) {}
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer-Header',
        section: 'cart-drawer',
        selector: '.drawer__header',
      },
      {
        id: 'CartDrawer-Items',
        section: 'cart-drawer',
        selector: 'cart-drawer-items',
      },
      {
        id: 'CartDrawer-Footer',
        section: 'cart-drawer',
        selector: '.drawer__footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


